<picture [class]="pictureClasses">
  <ng-container *ngIf="bannerImageConfig.avif">
    <source
      type="image/avif"
      [srcset]="bannerImageConfig.avif.mobile"
      media="(max-width: 962px)" />
    <source type="image/avif" [srcset]="bannerImageConfig.avif.desktop" />
  </ng-container>
  <ng-container *ngIf="bannerImageConfig.webp">
    <source
      type="image/webp"
      [srcset]="bannerImageConfig.webp.mobile"
      media="(max-width: 962px)" />
    <source type="image/webp" [srcset]="bannerImageConfig.webp.desktop" />
  </ng-container>
  <source
    type="image/jpg"
    [srcset]="bannerImageConfig.jpg.mobile"
    media="(max-width: 962px)" />
  <source type="image/jpg" [srcset]="bannerImageConfig.jpg.desktop" />
  <img [class]="imageClasses" alt="" loading="lazy" decoding="async" />
</picture>
